import request from '@/services/interceptor.js'

// Un solo endpoint generico condiviso da TipiManutenzione/TipiScadenzaMezzo/
// TipiPagamento per leggere/salvare la soglia di preavviso della riga che stanno
// modificando (categoria + id della tipologia), invece di tre endpoint dedicati.
export const get_impostazioni_notifiche = (categoria, tipoId) => {
    return request({
        url: '/impostazioni-notifiche',
        method: 'get',
        params: { categoria, tipoId },
        loadingBar: true
    })
}

export const salva_impostazioni_notifiche = (dati) => {
    return request({
        url: '/impostazioni-notifiche',
        method: 'put',
        data: dati,
        loadingBar: true
    })
}
